<template>
    <form autocomplete="off" @submit.stop.prevent>
        <div class="px-4">
            <!-- :readonly="citiesList && citiesList.length == 1" -->
            <v-autocomplete ref="city" v-model="city" label="Населенный пункт" item-text="name" return-object
                type="text" autocomplete="off" :items="sortedCityList" :disabled="!citiesList || citiesList.length == 0"
                :search-input.sync="citySearch" :loading="cityLoading" :hint="cityHint" persistent-hint>
                <template v-slot:no-data>
                    <div class="px-3 py-1" style="max-width: 100%">
                        По запросу <b>"{{citySearch}}"</b> не найдено не одного города.
                    </div>
                </template>
            </v-autocomplete>

            <v-autocomplete ref="street" label="Улица" :items="sortedStreetList" type="text" autocomplete="off"
                v-model="street" item-text="name" return-object :disabled="!streetsList || streetsList.length == 0"
                :search-input.sync="streetSearch" :loading="streetLoading" :hint="streetHint" persistent-hint>
                <template v-slot:no-data>
                    <div class="px-3 py-1" style="max-width: 100%">
                        По запросу <b>"{{streetSearch}}"</b> не найдено не одной улицы.
                    </div>
                </template>
            </v-autocomplete>

            <v-row no-gutters>

                <v-col md="6">
                    <v-autocomplete ref="house" v-model="house" label="Дом" item-text="name" return-object type="text"
                        autocomplete="off" class="mr-2" :items="housesList"
                        :disabled="!housesList || housesList.length == 0" :search-input.sync="houseSearch"
                        :loading="houseLoading" :hint="houseHint" persistent-hint>


                        <template v-slot:no-data>
                            <div class="px-3 py-1" style="max-width: 100%">
                                По запросу <b>"{{houseSearch}}"</b> не найдено не одного дома.
                            </div>
                        </template>
                    </v-autocomplete>
                </v-col>

                <v-col md="6">
                    <v-autocomplete ref="apartment" v-model="apartment" label="Квартира" item-text="name" type="text"
                        autocomplete="off" return-object :items="apartmentsList"
                        :disabled="!apartmentsList || apartmentsList.length == 0" class="ml-2"
                        :search-input.sync="apartmentSearch" :loading="apartmentLoading" :hint="apartmentHint"
                        persistent-hint>

                        <template v-slot:no-data>
                            <div class="px-3 py-1" style="max-width: 100%">
                                По запросу <b>"{{apartmentSearch}}"</b> не найдено не одной квартиры.
                            </div>
                        </template>
                    </v-autocomplete>
                </v-col>

            </v-row>

            <v-expand-transition>
                <v-alert v-show="notFound" :icon="false" type="info" outlined class="ma-0">
                    По данному адресу лицевых счетов не найдено. Измените условия поиска.
                </v-alert>


            </v-expand-transition>

            <div v-show="!notFound && accounts && accounts.length > 0">
                <v-select :items="accounts" v-model="account" item-text="account" type="text" label="Лицевой счет"
                    autocomplete="off" ref="account" persistent-hint
                    :hint="'Найдено лицевых счетов: ' + accounts.length" />

                <div class="d-flex justify-end mt-3">
                    <v-btn ref="okButton" @click.stop="$emit('find', account)" color="primary" depressed
                        :disabled="!nextEnabled" large>Далее
                    </v-btn>
                </div>
            </div>

        </div>
    </form>
</template>

<script>
    export default {
        watch: {

            city() {
                this.reset("city")
                if (this.city) {
                    this.fetchStreets(this.city.id)
                }
            },

            street() {
                this.reset("street")
                if (this.city && this.street) {
                    this.fetchHouses(this.city.id, this.street.id)
                }
            },

            house() {
                this.reset("house")
                if (this.city && this.street && this.house) {
                    if (this.house.complete) {
                        this.getAccount(this.city.id, this.street.id, this.house.id)
                    } else {
                        this.fetchApartmets(this.city.id, this.street.id, this.house.id)
                    }
                }
            },

            apartment() {
                this.reset("aparment")
                if (this.city && this.street && this.house && this.apartment) {
                    this.getAccount(
                        this.city.id,
                        this.street.id,
                        this.house.id,
                        this.apartment.id
                    )
                }
            },
        },

        computed: {
            nextEnabled() {
                return !!this.account
            },

            providerGuid() {
                return this.$store.state.options.providerGuid
            },

            sortedCityList() {
                return this.sortItems(this.citiesList, this.citySearch)
            },

            sortedStreetList() {
                return this.sortItems(this.streetsList, this.streetSearch)
            }
        },

        data() {

            return {

                cityLoading: false,
                streetLoading: false,
                houseLoading: false,
                apartmentLoading: false,

                cityHint: "",
                streetHint: "",
                houseHint: "",
                apartmentHint: "",

                citySearch: '',
                streetSearch: '',
                houseSearch: '',
                apartmentSearch: '',


                accounts: [],

                selectedAccount: null,

                city: null,
                citiesList: [],

                streetsList: [],
                street: null,

                housesList: [],
                house: null,

                apartmentsList: [],
                apartment: null,

                account: null,

                notFound: false,
            }

        },

        created() {
            this.fetchCities()
        },

        methods: {

            sortItems(items, term) {
                if (!items) return []
                return items.sort((a, b) => {
                    return a.name.toLowerCase().indexOf(term) < b.name.toLowerCase().indexOf(term) ? -1 : 1;
                })
            },

            reset(level) {
/* 
                console.log("reset level: ", level) */


                switch (level) {
                    case "city":
                        level = 0;
                        break;
                    case "street":
                        level = 1;
                        break;
                    case "house":
                        level = 2;
                        break;
                    case "aparment":
                        level = 3;
                        break;
                }


                if (level < 1) {
                    this.cityHint = ""
                    this.streetsList = []
                    this.street = null
                }

                if (level < 2) {
                    this.streetHint = ""
                    this.housesList = []
                    this.house = null
                }

                if (level < 3) {
                    this.houseHint = ""
                    this.apartmentsList = []
                    this.apartment = null
                }

                this.apartmentHint = ""
                this.accounts = []
                this.account = null
                this.notFound = false
            },

            fetchCities() {
                this.cityLoading = true
                this.$api.cities(this.providerGuid)
                    .then(citiesList => {
                        this.citiesList = citiesList.sort((a, b) => a.name.localeCompare(b.name))
                        if (citiesList && citiesList.length == 1) {
                            this.city = citiesList[0]
                        }
                    })
                    .catch(error => {
                        console.error('fetch cities: ', error)
                    })
                    .finally(() => {
                        this.cityLoading = false
                    })
            },

            fetchStreets(cityId) {
                this.streetLoading = true
                this.$api.streets(this.providerGuid, cityId)
                    .then(streetsList => {
                        this.streetsList = streetsList //.sort((a, b) => a.name.localeCompare(b.name))
                        if (!this.streetsList || this.streetsList.length == 0) {
                            this.cityHint = "По данному населенному пункту не найдено не одной улицы"
                        } else {
                            this.$nextTick(() => {
                                this.$refs.street.focus()
                            })
                        }
                    })
                    .catch(error => {
                        console.error('fetch streets: ', error)
                    })
                    .finally(() => {
                        this.streetLoading = false
                    })
            },

            fetchHouses(cityId, streetId) {
                this.houseLoading = true
                this.$api.houses(this.providerGuid, cityId, streetId)
                    .then(housesList => {
                        this.housesList = housesList //.sort((a, b) => a.name.localeCompare(b.name))
                        if (!this.housesList || this.housesList.length == 0) {
                            this.streetHint = "По данной улице не найдено не одного жилого дома."
                        } else {
                            this.$nextTick(() => {
                                this.$refs.house.focus()
                            })
                        }
                    })
                    .catch(error => {
                        console.error('fetch houses: ', error)
                    })
                    .finally(() => {
                        this.houseLoading = false
                    })
            },

            fetchApartmets(cityId, streetId, houseId) {
                this.apartmentLoading = true
                this.$api.aparts(this.providerGuid, cityId, streetId, houseId)
                    .then(apartmentsList => {
                        this.apartmentsList = apartmentsList //.sort((a, b) => a.name.localeCompare(b.name))
                        if (!this.apartmentsList || this.apartmentsList.length == 0) {
                            this.houseHint = "Нет жилых помещений"
                        } else {
                            this.$nextTick(() => {
                                this.$refs.apartment.focus()
                            })
                        }
                    })
                    .catch(error => {
                        console.error('fetch apartments: ', error)
                    })
                    .finally(() => {
                        this.apartmentLoading = false
                    })
            },

            getAccount(cityId, streedId, houseId, apartmentId) {

                this.$api.accounts(this.providerGuid, cityId, streedId, houseId, apartmentId)
                    .then(accounts => {

                        /*       console.log('accounts1: ', accounts) */



                        this.accounts = accounts.map(it => it.account)



                        if (this.accounts && this.accounts.length == 1) {
                            this.account = this.accounts[0]
 

                        } else if (this.accounts.length > 0) {
                            this.$nextTick(() => {
                                this.$refs.account.focus()
                            })
                        }

                        if ((!!apartmentId || (!!houseId && this.apartmentsList.length == 0)) && (!accounts ||
                                accounts.length == 0)) {
                            this.notFound = true
                        }
                    })
                    .catch(error => {
                        console.error('searchAccount ', error)
                    })
            },

        }
    }
</script>

<style>

</style>